import { render, staticRenderFns } from "./nav_iconC.vue?vue&type=template&id=56bad961&scoped=true"
import script from "./nav_iconC.vue?vue&type=script&lang=js"
export * from "./nav_iconC.vue?vue&type=script&lang=js"
import style0 from "./nav_iconC.vue?vue&type=style&index=0&id=56bad961&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56bad961",
  null
  
)

export default component.exports